import { render, staticRenderFns } from "./upcountrySendDialog.vue?vue&type=template&id=98a3a732"
import script from "./upcountrySendDialog.vue?vue&type=script&lang=js"
export * from "./upcountrySendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports